export const GET_USERINFO = 'GET_USERINFO';
export const GET_NAVLIST = 'GET_NAVLIST';
export const GET_CURRNAV = 'GET_CURRNAV';
export const SET_USERINFO = 'SET_USERINFO';
export const GET_SERVERAPIROOT = 'GET_SERVERAPIROOT';
export const SET_SERVERAPIROOT = 'SET_SERVERAPIROOT';
export const SET_CURRNAV = 'SET_CURRNAV';
export const GET_AUTH = 'GET_AUTH';
export const SET_AUTH = 'SET_AUTH';